import _extends from "@babel/runtime/helpers/extends";
import { CoreDomainSearchModule, CORE_DOMAIN_SEARCH_TRANSLATIONS_NS } from '@wix/core-domain-search';
import React, { useEffect } from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
export const SearchBar = _ref => {
  let {
    Layouts = {},
    onSubmit,
    ...props
  } = _ref;
  useEffect(() => {
    return () => {
      const {
        i18n
      } = getPremiumEssentialsSafe() ?? {};
      const locale = (i18n == null ? void 0 : i18n.language) ?? 'en';
      i18n == null || i18n.removeResourceBundle(locale, CORE_DOMAIN_SEARCH_TRANSLATIONS_NS);
    };
  }, []);
  return /*#__PURE__*/React.createElement(CoreDomainSearchModule.Provider, {
    Layouts: {
      customConfiguration: Layouts
    },
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    }
  }, /*#__PURE__*/React.createElement(CoreDomainSearchModule.SDK.Components.DomainSearchBar, _extends({
    onClear: () => {
      DomainSearchSuiteModule.SDK.domainSearchSuiteStore.resetState();
    },
    onSubmit: filters => {
      DomainSearchSuiteModule.SDK.domainSearchSuiteStore.resetState();
      onSubmit == null || onSubmit(filters);
    }
  }, props)));
};
//# sourceMappingURL=SearchBar.js.map